/* eslint-disable */
import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import Remove from '@material-ui/icons/Remove';
import { IconButton, Box } from '@material-ui/core';

export default function Header({ handleMinimize, handleClose, tabIndex = '0', t }) {
	return (
		<Box className="widget-header">
			<Box className="header-logo-area" />
			<Box className="header-controls-area">
				<IconButton
					data-testid="minimize"
					id="minimizeBtn"
					className="minimize-button"
					aria-label={t('minimize', 'Minimize')}
					tabIndex={tabIndex}
					onClick={handleMinimize}
				>
					<Remove />
				</IconButton>
				<IconButton
					data-testid="close-button"
					id="closeBtn"
					className="close-button"
					aria-label={t('close', 'Close')}
					tabIndex={tabIndex}
					onClick={handleClose}
				>
					<CloseIcon />
				</IconButton>
			</Box>
		</Box>
	);
}
